(function(){
  var drawer = document.getElementById('side-cart-drawer');
  var overlay = document.getElementById('side-cart-overlay');
  if (!drawer || !overlay) return;

  var isOpen = false;
  var isUpdating = false;
  var emptyCloseTimer = null;
  var localeRoot = (window.theme && window.theme.localeRootUrl) || '';

  function openDrawer() {
    if (emptyCloseTimer) { clearTimeout(emptyCloseTimer); emptyCloseTimer = null; }
    if (isOpen) return;
    isOpen = true;
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sc-body-lock');
    document.documentElement.classList.add('sc-body-lock');
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sc-body-lock');
    document.documentElement.classList.remove('sc-body-lock');
    scCollapseMap();
    scMapWasRequested = false;
    scCloseInstallPopup();
  }

  // ---- Post-ATC install popup (guest, PDP desktop, eligible product) ----
  var scInstallPopupHandle = null;

  function scCloseInstallPopup() {
    if (scInstallPopupHandle && typeof scInstallPopupHandle.close === 'function') {
      try { scInstallPopupHandle.close(); } catch (e) {}
    }
    scInstallPopupHandle = null;
  }

  // Eligibility prefixes mirror snippets/celorecomiendo-eligible.liquid.
  var SC_CR_PREFIXES = ['pantalla','touch','bateria','batería','flex','conector','puerto','tapa','botones','sensor','lentes','lente','auricular'];
  function scIsCelorecomiendoEligible(title) {
    if (!title) return false;
    var t = String(title).toLowerCase();
    for (var i = 0; i < SC_CR_PREFIXES.length; i++) {
      if (t.indexOf(SC_CR_PREFIXES[i]) === 0) return true;
    }
    var c15 = t.slice(0, 15), c14 = t.slice(0, 14);
    if (c15 === 'camara frontal ' || c15 === 'cámara frontal ' || c15 === 'camara trasera ' || c15 === 'cámara trasera ') return true;
    if (c14 === 'camara frontal' || c14 === 'cámara frontal' || c14 === 'camara trasera' || c14 === 'cámara trasera') return true;
    return false;
  }

  // Snapshot the cart count BEFORE the ATC fetch, so we can detect "side cart
  // was empty before this ATC" even after the ATC adds items.
  var scPreAtcCartCount = (window.theme && typeof window.theme.cartCount === 'number') ? window.theme.cartCount : 0;
  var scInstallPopupInFlight = false;

  var scInstallDebug = (function() {
    try {
      if (/[?&]debug_install_popup=1/.test(window.location.search)) return true;
    } catch (e) {}
    return false;
  })();
  function scLogInstall(msg, data) {
    if (!scInstallDebug) return;
    try { console.log('[install-popup]', msg, data || ''); } catch (e) {}
  }

  // Hover/focus prefetch on product cards (collection, search, etc.) so the
  // post-ATC install popup can render instantly when the user finally adds.
  // Safe no-op when Celorecomiendo helper is not loaded yet (PDP loads it
  // unconditionally; non-PDP pages load it via side-cart-drawer.liquid).
  var scPrefetchedProductIds = {};
  function scPrefetchForCard(card) {
    if (!card) return;
    if (!(window.theme && window.theme.celorecomiendoEnabled)) return;
    var pid = card.getAttribute('data-product-id');
    var ptitle = card.getAttribute('data-product-title') || '';
    if (!pid || scPrefetchedProductIds[pid]) return;
    if (!scIsCelorecomiendoEligible(ptitle)) return;
    if (window.theme && window.theme.customerId) return;
    if (window.innerWidth < 1024) return;
    var helper = window.Celorecomiendo;
    if (!helper || typeof helper.prefetch !== 'function') return;
    scPrefetchedProductIds[pid] = true;
    var apiBase = (window.celorecomiendo && window.celorecomiendo.apiBase) || '';
    try {
      helper.prefetch({
        apiBase: apiBase,
        productGid: 'gid://shopify/Product/' + pid,
        productTitle: ptitle,
        customerGid: ''
      });
    } catch (e) {}
  }
  document.addEventListener('mouseenter', function(e) {
    if (!e.target || !e.target.closest) return;
    var card = e.target.closest('.product-item[data-product-id]');
    if (card) scPrefetchForCard(card);
  }, true);
  document.addEventListener('focusin', function(e) {
    if (!e.target || !e.target.closest) return;
    var card = e.target.closest('.product-item[data-product-id]');
    if (card) scPrefetchForCard(card);
  });

  function scMaybeShowInstallPopup(addedItem) {
    try {
      if (scInstallPopupInFlight) { scLogInstall('skip: already in flight'); return; }
      // Gate -1: global Celorecomiendo system disabled.
      if (!(window.theme && window.theme.celorecomiendoEnabled)) { scLogInstall('skip: celorecomiendo disabled'); return; }
      // Gate 0: only fire when the ATC happens on a collection or search page.
      // Cart page and PDP adds explicitly do NOT trigger the popup.
      var tmpl = (window.theme && window.theme.template) || '';
      if (tmpl !== 'collection' && tmpl !== 'search') { scLogInstall('skip: template not collection/search', tmpl); return; }
      // Gate 1: guest only (no logged-in customer). Belt-and-suspenders:
      // theme.customerId comes from {{ customer.id | json }} and is the
      // primary signal; celorecomiendo.customerId is also set on the PDP for
      // logged-in customers, so we honor either.
      if (window.theme && window.theme.customerId) { scLogInstall('skip: logged in (theme.customerId)', window.theme.customerId); return; }
      if (window.celorecomiendo && window.celorecomiendo.customerId) { scLogInstall('skip: logged in (celorecomiendo.customerId)'); return; }
      // Gate 2: desktop only (>=1024px).
      if (window.innerWidth < 1024) { scLogInstall('skip: viewport <1024', window.innerWidth); return; }
      // Gate 3: build product context. Prefer the just-added cart item
      // (works on collection / search / any non-PDP ATC) and fall back to
      // window.celorecomiendo (set on eligible non-mayorista PDPs).
      var cr = window.celorecomiendo || {};
      var ctx = {
        apiBase: cr.apiBase,
        productId: (addedItem && addedItem.productId) || cr.productId || '',
        productGid: (addedItem && addedItem.productGid) || cr.productGid || '',
        productTitle: (addedItem && addedItem.productTitle) || cr.productTitle || '',
        customerGid: cr.customerGid || ''
      };
      if (!ctx.productId || !ctx.productTitle) { scLogInstall('skip: no product context', ctx); return; }
      // Gate 4: eligibility check by title prefix.
      if (!scIsCelorecomiendoEligible(ctx.productTitle)) { scLogInstall('skip: title not eligible', ctx.productTitle); return; }
      // Gate 5: side cart was empty before this ATC.
      if (scPreAtcCartCount > 0) { scLogInstall('skip: cart not empty before ATC', scPreAtcCartCount); return; }
      // Gate 6: one-shot per session.
      try {
        if (sessionStorage.getItem('cv_install_popup_shown') === '1') { scLogInstall('skip: one-shot flag set this session'); return; }
      } catch (e) {}
      // Gate 7: the helper must be present.
      if (!window.Celorecomiendo || typeof window.Celorecomiendo.openInstallPopup !== 'function') { scLogInstall('skip: helper not loaded'); return; }

      scLogInstall('opening popup', { productId: ctx.productId, title: ctx.productTitle });
      scInstallPopupInFlight = true;

      window.Celorecomiendo.openInstallPopup(ctx).then(function(handle) {
        scInstallPopupInFlight = false;
        if (handle) {
          scInstallPopupHandle = handle;
          // Only consume the one-shot when the popup actually renders; this
          // way a transient silent-fail (no location yet, API blip) doesn't
          // permanently suppress the popup for the rest of the session.
          try { sessionStorage.setItem('cv_install_popup_shown', '1'); } catch (e) {}
          scLogInstall('popup rendered');
        } else {
          scLogInstall('popup silent-failed (no location, no workshops, or API error)');
        }
      }).catch(function(err) {
        scInstallPopupInFlight = false;
        scLogInstall('popup error', err);
      });
    } catch (e) {
      scInstallPopupInFlight = false;
      scLogInstall('exception', e);
    }
    // Update the snapshot AFTER attempting, so subsequent ATCs see the new count.
    scPreAtcCartCount = 1;
  }

  function toggleDrawer() {
    if (isOpen) closeDrawer(); else openDrawer();
  }

  window.SideCart = { open: openDrawer, close: closeDrawer, toggle: toggleDrawer, refresh: function(cb){ refreshSideCart(cb); } };

  document.body.classList.add('sc-has-side-cart');

  drawer.addEventListener('click', function(e) {
    if (e.target.closest('#sc-close-btn')) closeDrawer();
  });
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) closeDrawer();
  });

  document.addEventListener('click', function(e) {
    var cartToggle = e.target.closest('[data-action="toggle-mini-cart"], .header__cart-toggle');
    if (!cartToggle) return;
    if (window.theme && window.theme.template === 'cart') return;
    e.preventDefault();
    e.stopPropagation();
    toggleDrawer();
  }, true);

  function scAddUpsellItems(form, quantity) {
    var upsells = [];

    var toolsRadio = form.querySelector('input[name="properties[tools_upsell]"][value="include"]:checked');
    if (toolsRadio) {
      var toolsBox = form.querySelector('#tools-upsell-box');
      if (toolsBox) {
        var toolsVid = toolsBox.getAttribute('data-variant-id');
        if (toolsVid) upsells.push({ id: parseInt(toolsVid, 10), quantity: quantity, properties: { '_bundle': 'tools' } });
      }
    }

    var toolsWRadio = form.querySelector('input[name="properties[tools_upsell_wholesale]"][value="include"]:checked');
    if (toolsWRadio) {
      var toolsWBox = form.querySelector('#tools-upsell-wholesale-box');
      if (toolsWBox) {
        var toolsWVid = toolsWBox.getAttribute('data-variant-id');
        if (toolsWVid) upsells.push({ id: parseInt(toolsWVid, 10), quantity: quantity, properties: { '_bundle': 'tools_wholesale' } });
      }
    }

    var iphoneCuboRadio = form.querySelector('input[name="properties[iphone_cubo_upsell]"][value="include"]:checked');
    if (iphoneCuboRadio) {
      var iphoneCuboBox = form.querySelector('#iphone-cubo-upsell-box');
      if (iphoneCuboBox) {
        var iphoneCuboVid = iphoneCuboBox.getAttribute('data-variant-id');
        if (iphoneCuboVid) upsells.push({ id: parseInt(iphoneCuboVid, 10), quantity: quantity, properties: { '_bundle': 'iphone-accessory' } });
      }
    }

    var iphoneCableRadio = form.querySelector('input[name="properties[iphone_cable_upsell]"][value="include"]:checked');
    if (iphoneCableRadio) {
      var iphoneCableBox = form.querySelector('#iphone-cable-upsell-box');
      if (iphoneCableBox) {
        var iphoneCableVid = iphoneCableBox.getAttribute('data-variant-id');
        if (iphoneCableVid) upsells.push({ id: parseInt(iphoneCableVid, 10), quantity: quantity, properties: { '_bundle': 'iphone-accessory' } });
      }
    }

    var warrantyRadio = form.querySelector('input[name="properties[warranty_upsell]"][value="include"]:checked');
    if (warrantyRadio) {
      var warrantyBox = form.querySelector('#warranty-upsell-box');
      if (warrantyBox) {
        var warrantyVid = warrantyBox.getAttribute('data-variant-id');
        if (warrantyVid) upsells.push({ id: parseInt(warrantyVid, 10), quantity: quantity, properties: { '_bundle': 'warranty' } });
      }
    }

    var adhesiveRadio = form.querySelector('input[name="properties[waterproof_adhesive]"][value="include"]:checked');
    if (adhesiveRadio) {
      var adhesiveBox = form.querySelector('#waterproof-adhesive-upsell');
      if (adhesiveBox) {
        var adhesiveVid = adhesiveBox.getAttribute('data-variant-id');
        if (adhesiveVid) {
          var adhesiveId = (adhesiveVid.match(/\d+$/) || [null])[0];
          if (adhesiveId) upsells.push({ id: parseInt(adhesiveId, 10), quantity: quantity, properties: { '_bundle': 'waterproof_adhesive' } });
        }
      }
    }

    if (!upsells.length) return Promise.resolve();

    return upsells.reduce(function(chain, item) {
      return chain.then(function() {
        return fetch(localeRoot + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(item),
          credentials: 'same-origin'
        }).catch(function() {});
      });
    }, Promise.resolve());
  }

  function scAjaxAddToCart(form, submitBtn) {
    var originalBtnHTML = '';
    if (submitBtn) {
      originalBtnHTML = submitBtn.innerHTML;
      submitBtn.setAttribute('disabled', 'disabled');
      submitBtn.innerHTML = '<svg class="atc-spinner" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> Agregando\u2026';
      submitBtn.style.opacity = '0.85';
      submitBtn.style.pointerEvents = 'none';
    }
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    var formData = new FormData(form);
    var quantity = parseInt(formData.get('quantity') || '1', 10);

    function restoreBtn() {
      if (submitBtn) {
        submitBtn.innerHTML = originalBtnHTML;
        submitBtn.removeAttribute('disabled');
        submitBtn.style.opacity = '';
        submitBtn.style.pointerEvents = '';
      }
    }

    // Snapshot cart count before this ATC so the install popup gate can tell
    // whether the side cart was empty pre-add.
    scPreAtcCartCount = (window.theme && typeof window.theme.cartCount === 'number') ? window.theme.cartCount : 0;

    fetch(localeRoot + '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: formData,
      credentials: 'same-origin'
    }).then(function(response) {
      if (response.ok) {
        return response.json().then(function(addedItem) { return addedItem; }, function() { return null; }).then(function(addedItem) {
          var pid = addedItem && (addedItem.product_id || (addedItem.items && addedItem.items[0] && addedItem.items[0].product_id));
          var ptitle = addedItem && (addedItem.product_title || addedItem.title || (addedItem.items && addedItem.items[0] && (addedItem.items[0].product_title || addedItem.items[0].title)));
          var addedCtx = pid ? {
            productId: String(pid),
            productGid: 'gid://shopify/Product/' + pid,
            productTitle: ptitle || ''
          } : null;
          // Fire popup immediately in parallel with upsells + refreshSideCart so
          // it appears at the same time as the drawer opens, not after.
          scMaybeShowInstallPopup(addedCtx);
          return scAddUpsellItems(form, quantity).then(function() {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            restoreBtn();
            refreshSideCart(function() {
              openDrawer();
              document.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
            });
          });
        });
      } else {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        restoreBtn();
        response.json().then(function(err) {
          var msg = (err && err.description) || 'Error al agregar al carrito';
          alert(msg);
        }).catch(function() {});
      }
    }).catch(function() {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      restoreBtn();
    });
  }

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (window.theme && window.theme.template === 'cart') return;
    e.preventDefault();
    e.stopPropagation();
    var submitBtn = form.querySelector('[type="submit"], button:not([type="button"])');
    scAjaxAddToCart(form, submitBtn);
  }, true);

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action="add-to-cart"]');
    if (!btn) return;
    if (window.theme && window.theme.template === 'cart') return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    scAjaxAddToCart(form, btn);
  }, true);

  document.addEventListener('product:added', function() {
    refreshSideCart(function() {
      openDrawer();
      document.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
      scMaybeShowInstallPopup();
    });
  });

  document.addEventListener('cart:refresh', function() {
    refreshSideCart();
  });

  function refreshSideCart(cb) {
    if (isUpdating) return;
    isUpdating = true;
    showSpinner();
    var url = (window.theme && window.theme.localeRootUrl || '') + '/cart?view=side-cart&timestamp=' + Date.now();
    fetch(url, { credentials: 'same-origin' })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newInner = tmp.querySelector('#sc-drawer-inner');
        if (newInner) {
          var scrollTop = 0;
          var body = drawer.querySelector('.sc-drawer__body');
          if (body) scrollTop = body.scrollTop;
          // The re-render replaces the map markup, so the Google Maps instance
          // has to be rebuilt. Remember whether it was open to restore it.
          var mapWasOpen = scMapExpanded;
          scMapInitialized = false;
          scMapExpanded = false;
          if (drawer) drawer.classList.remove('sc-map-open');
          scMap = null;
          scMarker = null;
          scCoverageOverlayMap = null;
          scCoverageOverlayApi = null;
          document.getElementById('sc-drawer-inner').innerHTML = newInner.innerHTML;
          var newBody = drawer.querySelector('.sc-drawer__body');
          if (newBody && scrollTop) newBody.scrollTop = scrollTop;
          bindSideCartEvents();
          updateSCDeliveryEstimates();
          updateSCLocation();
          if (mapWasOpen) scExpandMap();
        }
        var countEl = document.querySelector('.header__cart-count');
        if (countEl) {
          var scCount = drawer.querySelector('#sc-item-count');
          if (scCount) {
            var m = scCount.textContent.match(/\d+/);
            if (m) countEl.textContent = m[0];
          }
        }
        isUpdating = false;
        hideSpinner();
        if (typeof cb === 'function') cb();
      })
      .catch(function() {
        isUpdating = false;
        hideSpinner();
        if (typeof cb === 'function') cb();
      });
  }

  function showSpinner() {
    var sp = drawer.querySelector('.sc-loading-spinner');
    if (!sp) {
      sp = document.createElement('div');
      sp.className = 'sc-loading-spinner active';
      sp.innerHTML = '<div class="sc-spinner"></div>';
      drawer.querySelector('.sc-drawer__inner').style.position = 'relative';
      drawer.querySelector('.sc-drawer__inner').appendChild(sp);
    } else {
      sp.classList.add('active');
    }
  }

  function hideSpinner() {
    var sp = drawer.querySelector('.sc-loading-spinner');
    if (sp) sp.classList.remove('active');
  }

  function removeOrphanedWarranty(cart, removedSku) {
    if (!removedSku) return Promise.resolve(cart);
    var warrantySku = 'G' + removedSku;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].sku === warrantySku) {
        return fetch(localeRoot + '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: cart.items[i].key, quantity: 0 }),
          credentials: 'same-origin'
        }).then(function(r) { return r.json(); });
      }
    }
    return Promise.resolve(cart);
  }

  function syncWarrantyQuantity(cart, itemSku, newQty) {
    if (!itemSku || newQty <= 0) return Promise.resolve(cart);
    var warrantySku = 'G' + itemSku;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].sku === warrantySku && cart.items[i].quantity !== newQty) {
        return fetch(localeRoot + '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: cart.items[i].key, quantity: newQty }),
          credentials: 'same-origin'
        }).then(function(r) { return r.json(); });
      }
    }
    return Promise.resolve(cart);
  }

  function updateQuantity(lineKey, quantity, itemSku) {
    if (isUpdating) return;
    isUpdating = true;
    showSpinner();
    fetch(localeRoot + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
      credentials: 'same-origin'
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (quantity === 0 && itemSku) {
        return removeOrphanedWarranty(cart, itemSku);
      }
      if (quantity > 0 && itemSku) {
        return syncWarrantyQuantity(cart, itemSku, quantity);
      }
      return cart;
    })
    .then(function(cart) {
      isUpdating = false;
      var countEl = document.querySelector('.header__cart-count');
      if (countEl) countEl.textContent = cart.item_count;
      refreshSideCart();
      document.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
      if (cart.item_count === 0) {
        emptyCloseTimer = setTimeout(closeDrawer, 1000);
      }
    })
    .catch(function() {
      isUpdating = false;
      hideSpinner();
    });
  }

  function bindSideCartEvents() {
    var inner = document.getElementById('sc-drawer-inner');
    if (!inner) return;

    inner.querySelectorAll('[data-sc-action="decrease"]').forEach(function(btn) {
      btn.onclick = function() {
        var newQty = parseInt(btn.getAttribute('data-qty'), 10);
        updateQuantity(btn.getAttribute('data-line-key'), newQty, btn.getAttribute('data-item-sku'));
      };
    });
    inner.querySelectorAll('[data-sc-action="increase"]').forEach(function(btn) {
      btn.onclick = function() { updateQuantity(btn.getAttribute('data-line-key'), parseInt(btn.getAttribute('data-qty'), 10), btn.getAttribute('data-item-sku')); };
    });
    inner.querySelectorAll('[data-sc-action="remove"]').forEach(function(btn) {
      btn.onclick = function() { updateQuantity(btn.getAttribute('data-line-key'), 0, btn.getAttribute('data-item-sku')); };
    });

    var clearCartBtn = inner.querySelector('#sc-clear-cart-btn');
    if (clearCartBtn) {
      clearCartBtn.onclick = function() {
        var modalOverlay = document.getElementById('sc-clear-modal-overlay');
        if (!modalOverlay) return;
        modalOverlay.classList.add('sc-modal-open');

        var cancelBtn = modalOverlay.querySelector('#sc-clear-modal-cancel');
        var confirmBtn = modalOverlay.querySelector('#sc-clear-modal-confirm');

        function closeModal() {
          modalOverlay.classList.remove('sc-modal-open');
          if (confirmBtn) { confirmBtn.disabled = false; confirmBtn.textContent = 'Vaciar carrito'; }
          modalOverlay.onclick = null;
          if (cancelBtn) cancelBtn.onclick = null;
          if (confirmBtn) confirmBtn.onclick = null;
        }

        modalOverlay.onclick = function(ev) { if (ev.target === modalOverlay) closeModal(); };
        if (cancelBtn) cancelBtn.onclick = closeModal;
        if (confirmBtn) {
          confirmBtn.onclick = function() {
            confirmBtn.disabled = true;
            confirmBtn.textContent = 'Vaciando...';
            fetch(localeRoot + '/cart/clear.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin'
            })
            .then(function(r) { return r.json(); })
            .then(function() {
              var countEl = document.querySelector('.header__cart-count');
              if (countEl) countEl.textContent = '0';
              closeModal();
              refreshSideCart();
              document.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
              emptyCloseTimer = setTimeout(closeDrawer, 1000);
            })
            .catch(function() { closeModal(); hideSpinner(); });
          };
        }
      };
    }

    var csvToggle = inner.querySelector('[data-sc-action="toggle-csv"]');
    if (csvToggle) {
      csvToggle.onclick = function() {
        var section = csvToggle.closest('.sc-csv-section');
        if (section) section.classList.toggle('sc-csv-expanded');
      };
    }

    inner.querySelectorAll('.sc-warranty-upsell').forEach(function(upsell) {
      var vid = upsell.getAttribute('data-sc-warranty-vid');
      var wSku = upsell.getAttribute('data-sc-warranty-sku') || '';
      var pTitle = upsell.getAttribute('data-sc-warranty-title') || '';
      var priceSpan = upsell.querySelector('.sc-warranty-upsell__price');
      if (vid && priceSpan) {
        priceSpan.textContent = '...';
        fetch(localeRoot + '/variants/' + vid + '.js')
          .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function(v) {
            var amt = ((v.price / 100) * 0.85).toFixed(0);
            priceSpan.innerHTML = '+Q' + amt;
          })
          .catch(function() {
            if (!pTitle) { priceSpan.textContent = ''; return; }
            fetch(localeRoot + '/search/suggest.json?q=' + encodeURIComponent('Garantia ' + pTitle) + '&resources[type]=product&resources[limit]=5')
              .then(function(r) { return r.json(); })
              .then(function(data) {
                var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
                if (!prods.length) return;
                return Promise.all(prods.map(function(p) { return fetch(localeRoot + '/products/' + p.handle + '.js').then(function(r) { return r.json(); }); }));
              })
              .then(function(allProds) {
                if (!allProds) { priceSpan.textContent = ''; return; }
                var found = false;
                for (var i = 0; i < allProds.length; i++) {
                  for (var j = 0; j < allProds[i].variants.length; j++) {
                    var vr = allProds[i].variants[j];
                    if (String(vr.id) === String(vid) || vr.sku === wSku) {
                      var amt2 = ((vr.price / 100) * 0.85).toFixed(0);
                      priceSpan.innerHTML = '+Q' + amt2;
                      found = true; break;
                    }
                  }
                  if (found) break;
                }
                if (!found) priceSpan.textContent = '';
              })
              .catch(function() { priceSpan.textContent = ''; });
          });
      }
      var addBtn = upsell.querySelector('[data-sc-action="add-warranty"]');
      if (addBtn) {
        addBtn.onclick = function() {
          if (!vid) return;
          addBtn.disabled = true;
          addBtn.textContent = '...';
          var qty = parseInt(upsell.getAttribute('data-sc-warranty-qty') || '1', 10);
          fetch(localeRoot + '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(vid, 10), quantity: qty, properties: { '_bundle': 'warranty', '_added_from': 'side-cart' } }),
            credentials: 'same-origin'
          })
          .then(function(r) {
            if (!r.ok) throw new Error();
            refreshSideCart();
          })
          .catch(function() {
            addBtn.disabled = false;
            addBtn.textContent = 'Agregar';
            alert('No se pudo agregar la garantía. Intenta de nuevo.');
          });
        };
      }
    });

    inner.querySelectorAll('[data-sc-action="add-upsell"]').forEach(function(btn) {
      btn.onclick = function() {
        var vid = btn.getAttribute('data-sc-upsell-vid');
        if (!vid) return;
        var card = btn.closest('.sc-upsell-card');
        if (card) card.classList.add('sc-upsell-card--adding');
        var originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = '<svg class="atc-spinner" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> Agregando…';
        fetch(localeRoot + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1, properties: { '_added_from': 'side-cart-upsell' } }),
          credentials: 'same-origin'
        })
        .then(function(r) {
          if (!r.ok) throw new Error();
          refreshSideCart(function() {
            document.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
          });
        })
        .catch(function() {
          if (card) card.classList.remove('sc-upsell-card--adding');
          btn.disabled = false;
          btn.innerHTML = originalHTML;
          alert('No se pudo agregar el producto. Intenta de nuevo.');
        });
      };
    });

    var checkoutBtn = inner.querySelector('#sc-checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function() {
        scCheckoutFromDrawer(checkoutBtn);
      });
    }

    var titleLink = inner.querySelector('.sc-drawer__title');
    if (titleLink && titleLink.tagName === 'A') {
      titleLink.addEventListener('click', function() {
        closeDrawer();
      });
    }

    var upsellsRoot = inner.querySelector('.sc-upsells');
    var upsellsList = inner.querySelector('.sc-upsells__list');
    var upsellsToggle = inner.querySelector('.sc-upsells__toggle');
    if (upsellsRoot && upsellsToggle) {
      try {
        if (localStorage.getItem('sc-upsells-collapsed') === '1') {
          upsellsRoot.classList.add('sc-upsells--collapsed');
          upsellsToggle.setAttribute('aria-expanded', 'false');
        }
      } catch(e) {}
      upsellsToggle.addEventListener('click', function() {
        var collapsed = upsellsRoot.classList.toggle('sc-upsells--collapsed');
        upsellsToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        try { localStorage.setItem('sc-upsells-collapsed', collapsed ? '1' : '0'); } catch(e) {}
      });
    }
    if (upsellsRoot && upsellsList) {
      var expandUpsells = function() {
        upsellsRoot.classList.add('sc-upsells--expanded');
      };
      upsellsList.addEventListener('scroll', function() {
        if (upsellsList.scrollTop > 4) expandUpsells();
      }, { passive: true });
      upsellsList.addEventListener('wheel', function() {
        expandUpsells();
      }, { passive: true });
      upsellsList.addEventListener('touchmove', function() {
        expandUpsells();
      }, { passive: true });
      var body = inner.querySelector('.sc-drawer__body');
      if (body) {
        body.addEventListener('scroll', function() {
          if (body.scrollTop + body.clientHeight >= body.scrollHeight - 40) {
            expandUpsells();
          }
        }, { passive: true });
      }
    }

    bindPdfDownload(inner);
    bindCsvDownload(inner);
    bindCsvUpload(inner);
  }

  function bindPdfDownload(container) {
    var btn = container.querySelector('#sc-download-pdf');
    if (!btn) return;
    btn.addEventListener('click', function() {
      btn.disabled = true;
      btn.style.opacity = '0.6';
      function loadScript(src) {
        return new Promise(function(resolve, reject) {
          var s = document.createElement('script');
          s.src = src; s.onload = resolve; s.onerror = reject;
          document.head.appendChild(s);
        });
      }
      var libs = Promise.resolve();
      if (!window.jspdf) {
        libs = loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js')
          .then(function() { return loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js'); });
      }
      libs.then(function() {
        var dataEl = container.querySelector('#sc-quote-data');
        if (!dataEl) return;
        var items = JSON.parse(dataEl.textContent);
        var jsPDF = window.jspdf.jsPDF;
        var doc = new jsPDF('p', 'mm', 'a4');
        var pw = doc.internal.pageSize.getWidth();
        var customerName = btn.getAttribute('data-customer-name') || '';
        var logoUrl = btn.getAttribute('data-logo-url') || '';
        var now = new Date();
        var dateStr = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
        function fmtQ(cents) { return 'Q ' + Math.round(cents / 100); }
        function buildPdf(logoImg) {
          var orange = [255, 155, 0]; var darkText = [30, 30, 46]; var grey = [100, 100, 100];
          doc.setFillColor(255, 155, 0); doc.rect(0, 0, pw, 4, 'F');
          var headerY = 14;
          if (logoImg) {
            try { var logoW = 60; var logoH = logoW * (76 / 300); doc.addImage(logoImg, 'PNG', 14, headerY, logoW, logoH); headerY = 14 + logoH + 4; } catch (e) { headerY = 14; }
          }
          if (headerY === 14) {
            doc.setFont('helvetica', 'bold'); doc.setFontSize(26); doc.setTextColor(orange[0], orange[1], orange[2]); doc.text('CELOVENDO', 14, 24); headerY = 30;
          }
          doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor(grey[0], grey[1], grey[2]);
          doc.text('PBX: 2500-5252', pw - 14, 18, { align: 'right' });
          doc.text('20 calle 25-55 Centro Empresarial El Cortijo 3', pw - 14, 23, { align: 'right' });
          doc.text('zona 12 bodega 909', pw - 14, 28, { align: 'right' });
          doc.text('www.celovendo.com', pw - 14, 33, { align: 'right' });
          doc.setDrawColor(230, 230, 230); doc.setLineWidth(0.5); doc.line(14, headerY + 4, pw - 14, headerY + 4);
          var titleY = headerY + 16;
          doc.setFont('helvetica', 'bold'); doc.setFontSize(20); doc.setTextColor(darkText[0], darkText[1], darkText[2]); doc.text('COTIZACIÓN', 14, titleY);
          doc.setFont('helvetica', 'normal'); doc.setFontSize(11); doc.setTextColor(grey[0], grey[1], grey[2]);
          doc.text('Fecha: ' + dateStr, pw - 14, titleY, { align: 'right' });
          var timeStr = String(now.getHours()).padStart(2, '0') + ':' + String(now.getMinutes()).padStart(2, '0');
          doc.text('Hora: ' + timeStr, pw - 14, titleY + 6, { align: 'right' });
          var startY = titleY + 14;
          if (customerName) {
            doc.setFontSize(11); doc.setTextColor(darkText[0], darkText[1], darkText[2]); doc.setFont('helvetica', 'bold'); doc.text('Cliente:', 14, startY);
            doc.setFont('helvetica', 'normal'); doc.text(customerName, 14 + doc.getTextWidth('Cliente: '), startY); startY += 10;
          }
          var rows = []; var itemUrls = []; var grandTotal = 0;
          items.forEach(function(it) {
            grandTotal += it.line_total;
            rows.push([it.sku || '—', it.title || '', fmtQ(it.unit_price), String(it.quantity), fmtQ(it.line_total)]);
            itemUrls.push(it.url || '');
          });
          doc.autoTable({
            startY: startY,
            head: [['SKU', 'Producto', 'Precio Unit.', 'Cantidad', 'Total']],
            body: rows,
            styles: { font: 'helvetica', fontSize: 9, cellPadding: 5, lineColor: [230, 230, 230], lineWidth: 0.3 },
            headStyles: { fillColor: [255, 155, 0], textColor: 255, fontStyle: 'bold', halign: 'center', cellPadding: 6 },
            columnStyles: { 0: { cellWidth: 36, halign: 'center', overflow: 'visible' }, 1: { cellWidth: 'auto', textColor: [0, 90, 180] }, 2: { halign: 'right', cellWidth: 32 }, 3: { halign: 'center', cellWidth: 22 }, 4: { halign: 'right', cellWidth: 30 } },
            alternateRowStyles: { fillColor: [255, 249, 235] },
            theme: 'grid', tableLineColor: [230, 230, 230], tableLineWidth: 0.3,
            willDrawCell: function(data) {
              if (data.section === 'body' && data.column.index === 0) {
                var txt = data.cell.text.join(''); var pad = data.cell.padding('horizontal'); var maxW = data.cell.width - pad; var fs = 9;
                doc.setFontSize(fs);
                while (doc.getTextWidth(txt) > maxW && fs > 5) { fs -= 0.5; doc.setFontSize(fs); }
                data.cell.styles.fontSize = fs;
              }
            },
            didDrawCell: function(data) {
              if (data.section === 'body' && data.column.index === 1) {
                var url = itemUrls[data.row.index];
                if (url) {
                  doc.link(data.cell.x, data.cell.y, data.cell.width, data.cell.height, { url: url });
                  var txt = data.cell.text; var textX = data.cell.x + data.cell.padding('left');
                  for (var ti = 0; ti < txt.length; ti++) {
                    var lineY = data.cell.y + data.cell.padding('top') + ((ti + 1) * (data.cell.styles.fontSize * 0.3528) * 1.15);
                    var tw = doc.getTextWidth(txt[ti]);
                    doc.setDrawColor(0, 90, 180); doc.setLineWidth(0.2); doc.line(textX, lineY + 0.5, textX + tw, lineY + 0.5);
                  }
                }
              }
            }
          });
          var finalY = doc.lastAutoTable.finalY + 2;
          doc.setFillColor(255, 155, 0); doc.roundedRect(pw - 14 - 60, finalY, 60, 12, 2, 2, 'F');
          doc.setFont('helvetica', 'bold'); doc.setFontSize(12); doc.setTextColor(255, 255, 255);
          doc.text('Total: ' + fmtQ(grandTotal), pw - 14 - 30, finalY + 8, { align: 'center' });
          doc.setFontSize(8); doc.setFont('helvetica', 'italic'); doc.setTextColor(160, 160, 160);
          doc.text('Los precios y disponibilidad están sujetos a cambios sin previo aviso.', 14, finalY + 22);
          doc.text('Todos los productos están sujetos a nuestra política de garantía.', 14, finalY + 28);
          doc.text('Cotización autogenerada desde el carrito de www.celovendo.com', 14, finalY + 34);
          var ph = doc.internal.pageSize.getHeight();
          doc.setFillColor(255, 155, 0); doc.rect(0, ph - 4, pw, 4, 'F');
          doc.save('Cotizacion_Celovendo_' + dateStr + '.pdf');
        }
        if (logoUrl) {
          var img = new Image(); img.crossOrigin = 'anonymous';
          img.onload = function() {
            try { var c = document.createElement('canvas'); c.width = img.naturalWidth; c.height = img.naturalHeight; c.getContext('2d').drawImage(img, 0, 0); buildPdf(c.toDataURL('image/png')); } catch (e) { buildPdf(null); }
          };
          img.onerror = function() { buildPdf(null); };
          img.src = logoUrl;
        } else { buildPdf(null); }
      }).catch(function(e) {
        console.error('SC PDF error:', e);
      }).finally(function() {
        btn.disabled = false; btn.style.opacity = '1';
      });
    });
  }

  function bindCsvDownload(container) {
    var btn = container.querySelector('#sc-download-csv');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var dataEl = container.querySelector('#sc-quote-data');
      if (!dataEl) return;
      var items = JSON.parse(dataEl.textContent);
      if (!items.length) return;
      function fmtPrice(cents) { return String(Math.round(cents / 100)); }
      function escCSV(val) {
        var s = String(val);
        if (s.indexOf(',') !== -1 || s.indexOf('"') !== -1 || s.indexOf('\n') !== -1) return '"' + s.replace(/"/g, '""') + '"';
        return s;
      }
      var rows = [['SKU', 'Nombre', 'Precio Unitario', 'Cantidad', 'Total de Línea']];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        rows.push([escCSV(it.sku), escCSV(it.title), fmtPrice(it.unit_price), it.quantity, fmtPrice(it.line_total)]);
      }
      var csv = rows.map(function(r) { return r.join(','); }).join('\r\n');
      var blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      var now = new Date();
      a.href = url;
      a.download = 'Carrito_Celovendo_' + now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0') + '.csv';
      document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
    });
  }

  function bindCsvUpload(container) {
    var dropzone = container.querySelector('#sc-csv-dropzone');
    var fileInput = container.querySelector('#sc-csv-file-input');
    var browseBtn = container.querySelector('#sc-csv-browse-btn');
    var filenameEl = container.querySelector('#sc-csv-filename');
    var progressEl = container.querySelector('#sc-csv-progress');
    var progressBar = container.querySelector('#sc-csv-progress-bar');
    var progressText = container.querySelector('#sc-csv-progress-text');
    var resultsEl = container.querySelector('#sc-csv-results');
    var summaryEl = container.querySelector('#sc-csv-results-summary');
    var notfoundEl = container.querySelector('#sc-csv-notfound-list');
    var templateLink = container.querySelector('#sc-csv-download-template');

    if (!dropzone || !fileInput) return;

    if (templateLink) {
      templateLink.addEventListener('click', function(e) {
        e.preventDefault();
        var csv = '\uFEFF' + 'SKU,CANT\nEJEMPLO-001,5\nEJEMPLO-002,10\n';
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a'); a.href = url; a.download = 'Plantilla_Carga_Masiva.csv';
        document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
      });
    }

    if (browseBtn) browseBtn.addEventListener('click', function(e) { e.stopPropagation(); fileInput.click(); });
    dropzone.addEventListener('click', function() { fileInput.click(); });
    dropzone.addEventListener('dragover', function(e) { e.preventDefault(); dropzone.classList.add('sc-csv-dragover'); });
    dropzone.addEventListener('dragleave', function() { dropzone.classList.remove('sc-csv-dragover'); });
    dropzone.addEventListener('drop', function(e) {
      e.preventDefault(); dropzone.classList.remove('sc-csv-dragover');
      if (e.dataTransfer.files.length > 0) handleFile(e.dataTransfer.files[0]);
    });
    fileInput.addEventListener('change', function() { if (fileInput.files.length > 0) handleFile(fileInput.files[0]); });

    function handleFile(file) {
      filenameEl.textContent = file.name; filenameEl.style.display = 'block';
      resultsEl.style.display = 'none'; notfoundEl.style.display = 'none';
      var ext = file.name.split('.').pop().toLowerCase();
      if (ext === 'xlsx') {
        if (!window.XLSX) {
          var s = document.createElement('script');
          s.src = 'https://cdn.jsdelivr.net/npm/xlsx@0.18.5/dist/xlsx.full.min.js';
          s.onload = function() { readXlsx(file); };
          document.head.appendChild(s);
        } else { readXlsx(file); }
      } else {
        var reader = new FileReader();
        reader.onload = function(e) {
          var rows = parseCSV(e.target.result);
          if (rows.length === 0) { summaryEl.innerHTML = '<span class="sc-csv-results-notfound">Sin datos válidos.</span>'; resultsEl.style.display = 'block'; return; }
          processRows(rows);
        };
        reader.readAsText(file);
      }
    }

    function readXlsx(file) {
      var reader = new FileReader();
      reader.onload = function(e) {
        try {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, { type: 'array' });
          var sheet = workbook.Sheets[workbook.SheetNames[0]];
          var csvText = XLSX.utils.sheet_to_csv(sheet);
          var rows = parseCSV(csvText);
          if (rows.length === 0) { summaryEl.innerHTML = '<span class="sc-csv-results-notfound">Sin datos válidos.</span>'; resultsEl.style.display = 'block'; return; }
          processRows(rows);
        } catch (err) { summaryEl.innerHTML = '<span class="sc-csv-results-notfound">Error al leer XLSX.</span>'; resultsEl.style.display = 'block'; }
      };
      reader.readAsArrayBuffer(file);
    }

    function parseCSV(text) {
      text = text.replace(/^\uFEFF/, '');
      var lines = text.split(/\r?\n/).filter(function(l) { return l.trim() !== ''; });
      if (lines.length === 0) return [];
      var delimiter = lines[0].indexOf(';') !== -1 ? ';' : ',';
      var rows = []; var startIdx = 0;
      var firstCols = lines[0].split(delimiter).map(function(c) { return c.trim().toLowerCase().replace(/['"]/g, ''); });
      if (firstCols[0] === 'sku' && (firstCols.length < 2 || firstCols[1] === 'cant' || firstCols[1] === 'cantidad' || firstCols[1] === 'qty' || firstCols[1] === 'quantity')) startIdx = 1;
      for (var i = startIdx; i < lines.length; i++) {
        var cols = lines[i].split(delimiter).map(function(c) { return c.trim().replace(/^['"]|['"]$/g, ''); });
        var sku = cols[0]; var cant = parseInt(cols[1], 10);
        if (!sku) continue;
        if (isNaN(cant) || cant < 1) cant = 1;
        rows.push({ sku: sku, qty: cant });
      }
      return rows;
    }

    function processRows(rows) {
      progressEl.style.display = 'block'; progressBar.style.width = '0%';
      progressText.textContent = 'Procesando 0 de ' + rows.length + '...';
      dropzone.style.display = 'none';
      var added = 0; var notFound = []; var idx = 0;
      function next() {
        if (idx >= rows.length) { showResults(added, notFound, rows.length); return; }
        var row = rows[idx];
        var pct = Math.round(((idx + 1) / rows.length) * 100);
        progressBar.style.width = pct + '%';
        progressText.textContent = 'Buscando SKU: ' + row.sku + ' (' + (idx + 1) + ' de ' + rows.length + ')';
        searchAndAdd(row.sku, row.qty, function(success) {
          if (success) added++; else notFound.push({ sku: row.sku, qty: row.qty });
          idx++; setTimeout(next, 200);
        });
      }
      next();
    }

    function searchAndAdd(sku, qty, cb) {
      fetchProductBySku(sku, function(variantId) {
        if (!variantId) { cb(false); return; }
        fetch(localeRoot + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: qty }) })
          .then(function(r) { return r.json(); }).then(function() { cb(true); }).catch(function() { cb(false); });
      });
    }

    function fetchProductBySku(sku, cb) {
      var allHandles = [];
      trySuggest(sku, function(vid) {
        if (vid) { cb(vid); return; }
        trySearchPage(sku, allHandles, function(vid2) { cb(vid2 || null); });
      }, allHandles);
    }

    function trySuggest(sku, cb, allHandles) {
      fetch(localeRoot + '/search/suggest.json?q=' + encodeURIComponent(sku) + '&resources[type]=product&resources[limit]=10')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          var handles = extractHandles(products);
          handles.forEach(function(h) { if (allHandles.indexOf(h) === -1) allHandles.push(h); });
          matchSkuInHandles(sku, handles, 0, cb);
        }).catch(function() { cb(null); });
    }

    function trySearchPage(sku, alreadyTried, cb) {
      fetch(localeRoot + '/search?q=' + encodeURIComponent(sku) + '&type=product', { headers: { 'Accept': 'text/html' } })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var regex = /\/products\/([\w\-]+)/g; var match; var handles = [];
          while ((match = regex.exec(html)) !== null) {
            var h = match[1]; if (handles.indexOf(h) === -1 && alreadyTried.indexOf(h) === -1) handles.push(h);
          }
          if (handles.length === 0) { cb(null); return; }
          matchSkuInHandles(sku, handles, 0, cb);
        }).catch(function() { cb(null); });
    }

    function extractHandles(products) {
      var handles = [];
      for (var p = 0; p < products.length; p++) {
        var h = null;
        if (products[p].handle) h = products[p].handle;
        else if (products[p].url) { var parts = products[p].url.split('/'); h = parts[parts.length - 1].split('?')[0]; }
        if (h && handles.indexOf(h) === -1) handles.push(h);
      }
      return handles;
    }

    function matchSkuInHandles(sku, handles, idx, cb) {
      if (idx >= handles.length) { cb(null); return; }
      fetch(localeRoot + '/products/' + handles[idx] + '.js')
        .then(function(r) { return r.json(); })
        .then(function(prod) {
          var variants = prod.variants || [];
          for (var v = 0; v < variants.length; v++) {
            if (variants[v].sku && variants[v].sku.toLowerCase() === sku.toLowerCase()) { cb(variants[v].id); return; }
          }
          matchSkuInHandles(sku, handles, idx + 1, cb);
        }).catch(function() { matchSkuInHandles(sku, handles, idx + 1, cb); });
    }

    function showResults(added, notFound, total) {
      progressEl.style.display = 'none'; resultsEl.style.display = 'block';
      var html = '<span class="sc-csv-results-added">' + added + ' producto(s) agregado(s).</span>';
      if (notFound.length > 0) {
        html += '<br><span class="sc-csv-results-notfound">' + notFound.length + ' SKU(s) no encontrado(s).</span>';
        summaryEl.innerHTML = html;
        notfoundEl.style.display = 'block';
        notfoundEl.innerHTML = notFound.map(function(item) {
          return '<span>' + item.sku.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</span>';
        }).join('');
        downloadNotFoundCsv(notFound);
      } else {
        summaryEl.innerHTML = html;
      }
      if (added > 0) {
        setTimeout(function() { refreshSideCart(); }, 1000);
      } else {
        dropzone.style.display = 'flex';
      }
    }

    function downloadNotFoundCsv(notFound) {
      var csv = '\uFEFF' + 'SKU,CANT\n';
      for (var i = 0; i < notFound.length; i++) csv += notFound[i].sku + ',' + notFound[i].qty + '\n';
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      var d = new Date();
      a.href = url; a.download = 'SKUs_No_Encontrados_' + d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0') + '.csv';
      document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
    }
  }

  var scMap = null;
  var scMarker = null;
  var scMapInitialized = false;

  /*
   * Single confirmation criterion for the checkout button.
   *
   * A destination restored from the cv_location cookie is not a confirmation
   * by itself: the coverage engine restores it on every page load, so trusting
   * it alone sends a returning shopper straight to checkout without ever
   * seeing the map. Confirmation means the map is open in this session AND
   * coverage holds a precise destination. scMapExpanded resets when the drawer
   * closes or the cart re-renders, so each session confirms again.
   */
  function scLocationConfirmedThisSession() {
    return scMapExpanded && scCoverageIsPrecise(scCoverageDestination);
  }

  function scCheckInteractionRequirement() {
    var ready = scLocationConfirmedThisSession();
    var cBtn = document.getElementById('sc-checkout-btn');
    var msg = document.getElementById('sc-checkout-location-msg');
    // While the map is collapsed the button stays enabled: its first click is
    // what opens the map.
    if (cBtn) cBtn.disabled = scMapExpanded && !ready;
    if (msg) msg.style.display = scMapExpanded && !ready ? 'flex' : 'none';
    return ready;
  }

  var SC_DEFAULT_LAT = 14.595942230114066;
  var SC_DEFAULT_LNG = -90.53847044220376;
  var SC_GMAP_KEY = 'AIzaSyDU3KHHhOFI1cdoNLlVYKYZr7DqoiE_Qeo';

  function scReadCvCookie() {
    var nameEQ = 'cv_location=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        try { return JSON.parse(decodeURIComponent(c.substring(nameEQ.length))); } catch(e) { return null; }
      }
    }
    return null;
  }

  function scIsInsideGuatemala(lat, lng) {
    return lat >= 13.7 && lat <= 17.8 && lng >= -92.3 && lng <= -88.2;
  }

  // The coverage engine owns the cart attributes; this only flushes its
  // pending write before leaving for checkout.
  function scSaveLatLngToCart() {
    var coverage = scCoverageApi();
    if (!coverage || typeof coverage.ensureSaved !== 'function') {
      return Promise.reject(new Error('Coverage engine unavailable'));
    }
    return coverage.ensureSaved();
  }

  // Los atributos del carrito no llegan al servicio de tarifas del checkout;
  // solo las propiedades de línea. Estampar aquí es lo que permite ofrecer el
  // mensajero de 90 min. Nunca rechaza: sin marca el cliente ve Cargo Expreso.
  function scStampCartLines() {
    if (!window.CVPinStamp || typeof window.CVPinStamp.stampCartLines !== 'function') return Promise.resolve();
    return window.CVPinStamp.stampCartLines();
  }

  /*
   * Every map interaction routes through the coverage engine: it classifies
   * the point, writes the cart attributes and re-emits cv:coverage-changed,
   * which location-service mirrors back into cv_location (and into the search
   * label). The drawer never writes Latitude/Longitude itself.
   */
  function scUpdateMapLocationUI(lat, lng, source) {
    scCoverageSetDestination(lat, lng, source || 'side-cart-map');
  }

  var scSearchUserEditing = false;

  function scFillSearchWithLocation(cityZone, muni) {
    if (scSearchUserEditing) return;
    var input = document.getElementById('sc-map-search-input');
    if (!input) return;
    var label = cityZone || muni || '';
    if (label) {
      input.value = label;
      scToggleClearBtn(true);
    }
  }

  function scToggleClearBtn(show) {
    var btn = document.getElementById('sc-map-search-clear');
    if (btn) btn.style.display = show ? 'block' : 'none';
  }

  function scLoadGoogleMaps(cb) {
    if (window.google && window.google.maps && window.google.maps.places) { cb(); return; }
    if (window.google && window.google.maps && !window.google.maps.places) {
      var s2 = document.createElement('script');
      s2.src = 'https://maps.googleapis.com/maps/api/js?key=' + SC_GMAP_KEY + '&libraries=places&v=weekly';
      s2.async = true;
      s2.onload = function() { cb(); };
      document.head.appendChild(s2);
      return;
    }
    if (document.querySelector('script[src*="maps.googleapis.com"]')) {
      var attempts = 0;
      var check = setInterval(function() {
        if (window.google && window.google.maps) { clearInterval(check); cb(); }
        if (++attempts > 50) clearInterval(check);
      }, 200);
      return;
    }
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' + SC_GMAP_KEY + '&libraries=places&v=weekly';
    s.async = true;
    s.onload = function() { cb(); };
    document.head.appendChild(s);
  }

  function scMapSeedPoint() {
    // Coverage state is the authority; cart attributes and the cookie are
    // only fallbacks so the map opens where the shopper left it.
    var api = scCoverageApi();
    var state = api && typeof api.getState === 'function' ? api.getState() : null;
    var saved = state && (state.location || state.destination);
    if (scCoverageIsPrecise(saved)) return { lat: saved.lat, lng: saved.lng, state: state, location: saved };

    var attrLat = parseFloat((document.getElementById('sc-map-lat') || {}).value);
    var attrLng = parseFloat((document.getElementById('sc-map-lng') || {}).value);
    if (!isNaN(attrLat) && !isNaN(attrLng) && scIsInsideGuatemala(attrLat, attrLng)) {
      return { lat: attrLat, lng: attrLng };
    }

    var cookieLoc = scReadCvCookie();
    if (cookieLoc && typeof cookieLoc.lat === 'number' && typeof cookieLoc.lng === 'number' &&
        scIsInsideGuatemala(cookieLoc.lat, cookieLoc.lng)) {
      return { lat: cookieLoc.lat, lng: cookieLoc.lng };
    }
    return null;
  }

  function scInitMap() {
    var container = document.getElementById('sc-map-canvas');
    if (!container || scMapInitialized) return;

    scLoadGoogleMaps(function() {
      if (scMapInitialized || !window.google || !google.maps) return;
      scMapInitialized = true;

      var seed = scMapSeedPoint();
      var center = new google.maps.LatLng(
        seed ? seed.lat : SC_DEFAULT_LAT,
        seed ? seed.lng : SC_DEFAULT_LNG
      );

      scMap = new google.maps.Map(container, {
        center: center,
        zoom: 15,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        gestureHandling: 'greedy',
        draggable: true,
        scrollwheel: true,
        disableDoubleClickZoom: false,
        zoomControl: true,
        zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_CENTER }
      });

      scMarker = new google.maps.Marker({
        position: center,
        map: scMap,
        draggable: true,
        optimized: false,
        zIndex: 1000,
        opacity: 0
      });

      scAttachCoverageOverlays();
      // Only a destination the coverage engine already classified renders as
      // confirmed. A seed taken from the cart attributes or the cookie just
      // centers the map: the shopper still confirms it here.
      if (seed && seed.location) scCoverageApply(seed.location, seed.state && seed.state.coverage);

      google.maps.event.addListener(scMap, 'idle', function() {
        // Keep the invisible drag marker under the static center pin without
        // re-centering the map, which would fight programmatic recenters.
        if (!scCoverageMapChange && scMarker) scMarker.setPosition(scMap.getCenter());
      });

      google.maps.event.addListener(scMap, 'dragstart', function() {
        var hint = document.getElementById('sc-map-drag-hint');
        if (hint) hint.style.display = 'none';
        scCoverageInvalidate();
      });

      google.maps.event.addListener(scMap, 'dragend', function() {
        var pos = scMap.getCenter();
        scMarker.setPosition(pos);
        scUpdateMapLocationUI(pos.lat(), pos.lng(), 'side-cart-map');
      });

      google.maps.event.addListener(scMarker, 'dragstart', function() {
        var hint = document.getElementById('sc-map-drag-hint');
        if (hint) hint.style.display = 'none';
        scCoverageInvalidate();
      });

      google.maps.event.addListener(scMarker, 'dragend', function() {
        var pos = scMarker.getPosition();
        scMap.setCenter(pos);
        scUpdateMapLocationUI(pos.lat(), pos.lng(), 'side-cart-marker');
      });

      var scGpsBtnDefaultHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/></svg> Compartir mi ubicación GPS';
      var locateBtn = document.getElementById('sc-map-locate-btn');
      if (locateBtn) {
        locateBtn.addEventListener('click', function(e) {
          e.preventDefault();
          if (!navigator.geolocation) {
            scCoverageStatus(null, false, 'Tu navegador no soporta geolocalización.');
            return;
          }
          var revision = scCoverageInvalidate();
          locateBtn.disabled = true;
          locateBtn.innerHTML = '<span class="sc-spinner" style="width:18px;height:18px;display:inline-block;vertical-align:middle;"></span> Buscando tu ubicación...';
          navigator.geolocation.getCurrentPosition(function(position) {
            locateBtn.disabled = false;
            locateBtn.innerHTML = scGpsBtnDefaultHTML;
            if (revision !== scCoverageRevision) return;
            scSearchUserEditing = false;
            var lat = position.coords.latitude;
            var lng = position.coords.longitude;
            var newPos = new google.maps.LatLng(lat, lng);
            scMap.setCenter(newPos);
            scMarker.setPosition(newPos);
            scUpdateMapLocationUI(lat, lng, 'side-cart-gps');
          }, function() {
            locateBtn.disabled = false;
            locateBtn.innerHTML = scGpsBtnDefaultHTML;
            if (revision === scCoverageRevision) {
              scCoverageStatus(null, false, 'No se pudo obtener tu ubicación. Verifica los permisos e intenta nuevamente.');
            }
          }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 });
        });
      }

      var scSearchInput = document.getElementById('sc-map-search-input');
      if (scSearchInput) {
        scSearchInput.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.keyCode === 13) {
            var pacActive = document.querySelector('.pac-item-selected');
            if (!pacActive) {
              var downEvt = new KeyboardEvent('keydown', { key: 'ArrowDown', keyCode: 40, which: 40, bubbles: true });
              scSearchInput.dispatchEvent(downEvt);
            }
          }
        });
        // Typing only marks the field as user-owned so the coverage label does
        // not overwrite it mid-edit. The destination changes when a suggestion
        // is picked, never on a keystroke, so a half-typed query cannot strand
        // the shopper with a permanently pending coverage check.
        scSearchInput.addEventListener('input', function() {
          scSearchUserEditing = true;
          scToggleClearBtn(scSearchInput.value.length > 0);
        });
        scSearchInput.addEventListener('focus', function() {
          scSearchUserEditing = true;
        });
        var scClearBtn = document.getElementById('sc-map-search-clear');
        if (scClearBtn) {
          scClearBtn.addEventListener('click', function() {
            scSearchInput.value = '';
            scSearchUserEditing = true;
            scToggleClearBtn(false);
            scSearchInput.focus();
          });
        }
      }

      if (scSearchInput && google.maps.places) {
        var scAutocomplete = new google.maps.places.Autocomplete(scSearchInput, {
          componentRestrictions: { country: 'gt' },
          fields: ['geometry', 'name']
        });
        scAutocomplete.bindTo('bounds', scMap);
        scAutocomplete.addListener('place_changed', function() {
          var place = scAutocomplete.getPlace();
          if (!place.geometry || !place.geometry.location) return;
          var loc = place.geometry.location;
          scMap.setCenter(loc);
          scMap.setZoom(17);
          scMarker.setPosition(loc);
          scToggleClearBtn(scSearchInput.value.length > 0);
          scUpdateMapLocationUI(loc.lat(), loc.lng(), 'side-cart-search');
        });
      }

    });
  }

  document.addEventListener('cv:location-changed', function(e) {
    if (!e.detail || typeof e.detail.lat !== 'number') return;
    scSearchUserEditing = false;
    if (scMap && scMarker) {
      var newPos = new google.maps.LatLng(e.detail.lat, e.detail.lng);
      scMap.setCenter(newPos);
      scMarker.setPosition(newPos);
    }
    // Location service acknowledgements (including coverageSynced updates)
    // are presentation-only here. Calling the map setter from this listener
    // re-emits setLocation -> cv:location-changed and starts another coverage
    // classification/save cycle. User map/GPS/search interactions call the
    // coverage setter directly in the current scInitMap implementation.
    if (e.detail.cityZone || e.detail.muni) {
      scFillSearchWithLocation(e.detail.cityZone, e.detail.muni);
    }
  });

  function scHydrateHiddenFieldsFromCookie() {
    var savedLoc = scReadCvCookie();
    if (savedLoc && typeof savedLoc.lat === 'number' && typeof savedLoc.lng === 'number' && scIsInsideGuatemala(savedLoc.lat, savedLoc.lng)) {
      var latEl = document.getElementById('sc-map-lat');
      var lngEl = document.getElementById('sc-map-lng');
      if (latEl && !latEl.value) latEl.value = savedLoc.lat;
      if (lngEl && !lngEl.value) lngEl.value = savedLoc.lng;
    }
  }

  var scMapExpanded = false;

  var scMapWasRequested = false;

  // Mirrors the coverage engine's current state into the drawer. Returns true
  // when that state is a precise, verified destination.
  function scDerivePreConfirmed() {
    var api = scCoverageApi();
    var state = api && typeof api.getState === 'function' ? api.getState() : null;
    var location = state && (state.location || state.destination);
    return scCoverageApply(location, state && state.coverage);
  }

  function scExpandMap() {
    var mapSection = document.getElementById('sc-map-section');
    if (!mapSection) return;
    scMapWasRequested = true;
    if (scMapExpanded) {
      mapSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    scMapExpanded = true;
    mapSection.classList.remove('sc-map-collapsed');
    mapSection.classList.add('sc-map-expanded');
    drawer.classList.add('sc-map-open');
    if (!scDerivePreConfirmed()) scCoverageStatus(null, false);
    scCheckInteractionRequirement();

    setTimeout(function() {
      if (!scMapInitialized) {
        scInitMap();
      } else if (scMap) {
        google.maps.event.trigger(scMap, 'resize');
      }
      setTimeout(function() {
        mapSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }, 350);
  }

  function scCollapseMap() {
    var mapSection = document.getElementById('sc-map-section');
    if (mapSection) {
      mapSection.classList.remove('sc-map-expanded');
      mapSection.classList.add('sc-map-collapsed');
    }
    scMapExpanded = false;
    if (drawer) drawer.classList.remove('sc-map-open');
    // Collapsing lifts the location requirement, so the button has to be
    // re-enabled: otherwise closing the map without picking a point leaves a
    // dead checkout button that can no longer reopen it.
    scCheckInteractionRequirement();
  }

  var origOpenDrawer = openDrawer;
  openDrawer = function() {
    origOpenDrawer();
    scHydrateHiddenFieldsFromCookie();
    scDerivePreConfirmed();
    scCheckInteractionRequirement();
    scAttachCoverageOverlays();
    if (scMapWasRequested) {
      setTimeout(function() { scExpandMap(); }, 100);
    }
  };
  window.SideCart.open = openDrawer;


  function updateSCDeliveryEstimates() {
    if (!window.CelovendoLocation || !window.CelovendoGeo) return;
    var loc = window.CelovendoLocation.getLocation();
    if (!loc || !loc.zone || !loc.confirmed) return;
    var config = window.CelovendoLocation.getConfig();
    if (!config) return;
    var items = document.querySelectorAll('.cv-sc-delivery');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var productType = el.getAttribute('data-product-type') || 'immediate';
      if (productType === 'immediate' && el.hasAttribute('data-stock-xela') && loc.zone === 'messenger_xela') productType = 'xela';
      var textEl = el.querySelector('.cv-cart-delivery-estimate__text');
      if (!textEl) continue;
      var zoneInfo = { zone: loc.zone, municipio: loc.muni, departamento: loc.dept, cityZone: loc.cityZone };
      var estimate = window.CelovendoGeo.calculateEstimate(zoneInfo, productType, config);
      var iconColors = { immediate: '#2e7d32', backorder: '#e65100', slowback: '#e65100', xela: '#2e7d32' };
      var iconColor = iconColors[productType] || '#2e7d32';
      if (estimate) {
        textEl.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="' + iconColor + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px;margin-right:3px;"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' + estimate.formatted;
        el.style.display = 'block';
      }
    }
  }

  function updateSCLocation() {
    var indicator = document.getElementById('sc-location-indicator');
    var textEl = document.getElementById('sc-location-text');
    if (!indicator || !textEl || !window.CelovendoLocation) return;
    var loc = window.CelovendoLocation.getLocation();
    if (loc && loc.confirmed && loc.muni) {
      textEl.textContent = loc.muni + (loc.dept ? ', ' + loc.dept : '');
      indicator.style.display = 'flex';
    }
  }

  function onLocationEvent() {
    updateSCDeliveryEstimates();
    updateSCLocation();
  }

  document.addEventListener('cv:location-ready', onLocationEvent);
  document.addEventListener('cv:location-changed', onLocationEvent);

  (function initSwipeGestures() {
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartOnDrawer = false;
    var touchStartOnMap = false;
    var swipeThreshold = 60;

    document.addEventListener('touchstart', function(e) {
      var t = e.touches[0];
      touchStartX = t.clientX;
      touchStartY = t.clientY;
      touchStartOnDrawer = !!(e.target.closest('.sc-drawer') || e.target.closest('.sc-overlay'));
      touchStartOnMap = !!(e.target.closest('.sc-map-container') || e.target.closest('.sc-map-search-input') || e.target.closest('.pac-container'));
    }, { passive: true });

    document.addEventListener('touchend', function(e) {
      if (touchStartOnMap) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - touchStartX;
      var dy = Math.abs(t.clientY - touchStartY);
      if (dy > Math.abs(dx)) return;

      if (isOpen && touchStartOnDrawer && dx > swipeThreshold) {
        closeDrawer();
      }

      if (!isOpen && touchStartX > window.innerWidth - 30 && dx < -swipeThreshold) {
        openDrawer();
      }
    }, { passive: true });
  })();

  /*
   * Coverage is the authority for destination state and cart attributes.  The
   * drawer only renders that state; it must never persist Latitude/Longitude
   * itself because a cart page and a drawer can otherwise race each other.
   */
  var scCoverageDestination = null;
  var scCoverageRevision = 0;
  var scCoverageMapChange = false;
  var scCoverageSawSaving = {};
  var scCoverageOverlayMap = null;
  var scCoverageOverlayApi = null;

  function scCoverageApi() {
    return window.CelovendoCoverage || null;
  }

  function scCoverageIsPrecise(location) {
    return !!(location && typeof location.lat === 'number' && typeof location.lng === 'number' &&
      location.confirmed === true && location.precise !== false);
  }

  function scCoverageStatus(coverage, pending, error) {
    var el = document.getElementById('sc-coverage-status');
    var outside = document.getElementById('sc-map-outside-warning');
    if (!el) return;
    el.className = 'sc-coverage-status is-visible';
    if (outside) outside.style.display = 'none';
    if (pending) {
      el.className += ' is-pending';
      el.textContent = 'Verificando cobertura para esta ubicación…';
      return;
    }
    if (error) {
      el.className += ' is-error';
      el.textContent = error;
      return;
    }
    if (!coverage) {
      el.textContent = 'Selecciona una ubicación precisa para ver la cobertura.';
      return;
    }
    var status = String(coverage.delivery_coverage_status || '').toLowerCase();
    if (status === 'unknown' || status === 'pending' || status === 'pendiente') {
      el.className += ' is-pending';
      el.textContent = 'Verificando cobertura para esta ubicación…';
      return;
    }
    if (status === 'outside' || status === 'out_of_coverage' || status === 'unavailable' || status === 'not_covered') {
      el.className += ' is-error';
      el.textContent = 'Esta ubicación está fuera de nuestra cobertura de entrega.';
      if (outside) {
        outside.textContent = el.textContent;
        outside.style.display = 'block';
      }
      return;
    }
    el.className += ' is-covered';
    var zone = coverage.delivery_zone ? ' · ' + coverage.delivery_zone : '';
    el.textContent = coverage.delivery_method ? 'Cobertura confirmada: ' + coverage.delivery_method + zone : 'Cobertura confirmada para esta ubicación.';
  }

  function scCoverageStoreNotice(result, attachError) {
    var el = document.getElementById('sc-coverage-store-notice');
    if (!el) return;
    var errors = result && result.storeErrors;
    var missing = errors && Object.keys(errors).filter(function(name) { return !!errors[name]; });
    if (attachError) {
      el.className = 'sc-coverage-store-notice is-visible';
      el.textContent = 'No se pudieron mostrar las zonas de cobertura en el mapa. Intenta nuevamente.';
      return;
    }
    if (!missing || !missing.length) {
      el.className = 'sc-coverage-store-notice';
      el.textContent = '';
      return;
    }
    var names = missing.map(function(name) { return name === 'xela' ? 'Tienda Xela' : 'Tienda Guatemala'; });
    el.className = 'sc-coverage-store-notice is-visible';
    el.textContent = 'Marcador no disponible: ' + names.join(' y ') + '. Configura sus coordenadas para mostrarlo.';
  }

  function scAttachCoverageOverlays() {
    var api = scCoverageApi();
    if (!scMap || !api || typeof api.load !== 'function' || typeof api.attachGoogleMap !== 'function') return null;
    // Maps and the deferred coverage script may finish in either order. The
    // map/API pair also prevents duplicate polygon and store-marker overlays.
    if (scCoverageOverlayMap === scMap && scCoverageOverlayApi === api) return null;
    var targetMap = scMap;
    scCoverageOverlayMap = targetMap;
    scCoverageOverlayApi = api;
    return api.load().then(function() {
      if (scMap !== targetMap || scCoverageOverlayApi !== api) return null;
      return api.attachGoogleMap(targetMap).then(function(result) {
        if (scMap === targetMap) scCoverageStoreNotice(result);
      }).catch(function() {
        if (scMap === targetMap) scCoverageStoreNotice(null, true);
      });
    }).catch(function() {
      if (scMap === targetMap) scCoverageStatus(null, false, 'No se pudo cargar la cobertura. Intenta nuevamente.');
    });
  }

  function scCoverageApply(location, coverage, verificationError) {
    if (!scCoverageIsPrecise(location)) {
      scCoverageDestination = null;
      scCoverageStatus(null, false);
      return false;
    }
    scCoverageDestination = {
      lat: location.lat, lng: location.lng, confirmed: true, precise: true
    };
    var latEl = document.getElementById('sc-map-lat');
    var lngEl = document.getElementById('sc-map-lng');
    if (latEl) latEl.value = location.lat;
    if (lngEl) lngEl.value = location.lng;
    scCoverageStatus(coverage, false, verificationError);
    scCheckInteractionRequirement();
    return true;
  }

  function scCoverageInvalidate() {
    scCoverageRevision++;
    scCoverageDestination = null;
    var api = scCoverageApi();
    if (api && typeof api.invalidate === 'function') api.invalidate();
    scCoverageStatus(null, true);
    scCheckInteractionRequirement();
    return scCoverageRevision;
  }

  function scCoverageSetDestination(lat, lng, source) {
    var revision = scCoverageInvalidate();
    if (typeof lat !== 'number' || typeof lng !== 'number') return;
    var location = { lat: lat, lng: lng, confirmed: true, precise: true, source: source || 'map' };
    var api = scCoverageApi();
    if (!api || typeof api.setDestination !== 'function') {
      scCoverageStatus(null, false, 'No se pudo cargar la cobertura. Intenta nuevamente.');
      return;
    }
    try {
      var request = api.setDestination(location);
      if (request && typeof request.then === 'function') {
        request.then(function(state) {
          if (revision === scCoverageRevision) scCoverageApply((state && state.location) || location, state && state.coverage);
        }).catch(function() {
          if (revision === scCoverageRevision) scCoverageStatus(null, false, 'No se pudo verificar la cobertura. Intenta nuevamente.');
        });
      } else if (revision === scCoverageRevision) {
        scCoverageApply(location, null);
      }
    } catch (err) {
      if (revision === scCoverageRevision) scCoverageStatus(null, false, 'No se pudo verificar la cobertura. Intenta nuevamente.');
    }
  }

  function scCheckoutFromDrawer(button) {
    // The first click always opens the map, even when a destination was
    // restored from a previous visit. Skipping it here is what made checkout
    // silently bypass the map.
    if (!scMapExpanded) { scExpandMap(); return; }
    if (!scCheckInteractionRequirement()) {
      scCoverageStatus(null, false, 'Selecciona una ubicación precisa para continuar.');
      var section = document.getElementById('sc-map-section');
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    button.disabled = true;
    button.innerHTML = '<span class="sc-spinner" style="width:16px;height:16px;display:inline-block;vertical-align:middle;margin-right:6px;"></span> Procesando...';
    scSaveLatLngToCart().then(scStampCartLines).then(function() {
      window.location.href = window.__scWholesaleDiscountUrl || (localeRoot + '/checkout');
    }).catch(function() {
      button.disabled = false;
      button.textContent = 'Reintentar pago';
      scCoverageStatus(null, false, 'No pudimos guardar tu ubicación. Reintenta para continuar al pago.');
    });
  }

  document.addEventListener('cv:coverage-changed', function(e) {
    var detail = e.detail || {};
    scAttachCoverageOverlays();
    var eventRevision = typeof detail.revision === 'number' ? detail.revision : null;
    if (eventRevision !== null) scCoverageRevision = Math.max(scCoverageRevision, eventRevision);
    if (eventRevision !== null && detail.saving) scCoverageSawSaving[eventRevision] = true;
    if (!scCoverageIsPrecise(detail.location)) {
      scCoverageDestination = null;
      scCoverageStatus(null, false, detail.saveError || null);
      scCheckInteractionRequirement();
      return;
    }
    var coverageStatus = String((detail.coverage || {}).delivery_coverage_status || '').toLowerCase();
    var verificationError = detail.saveError || null;
    if (!verificationError && (coverageStatus === 'unknown' || coverageStatus === 'pending' || coverageStatus === 'pendiente') &&
        eventRevision !== null && scCoverageSawSaving[eventRevision] && !detail.saving) {
      verificationError = 'No fue posible verificar la cobertura. Puedes reintentar o continuar con la ubicación guardada.';
    }
    scCoverageApply(detail.location, detail.coverage, verificationError);
    if (scMap && scMarker && !scCoverageMapChange) {
      scCoverageMapChange = true;
      var pos = new google.maps.LatLng(detail.location.lat, detail.location.lng);
      scMap.setCenter(pos); scMarker.setPosition(pos);
      scCoverageMapChange = false;
    }
  });
  // CelovendoCoverage already consumes cv:location-ready/changed. Do not
  // forward them a second time from the drawer: location-service also emits
  // coverageSynced acknowledgements, and forwarding either event can create
  // another classify/save cycle. The legacy changed listener above only
  // mirrors the pin and search label for presentation.

  bindSideCartEvents();
  setTimeout(function() { updateSCDeliveryEstimates(); updateSCLocation(); }, 700);

})();
